import { get, toLower } from 'lodash';
import * as React from 'react';
import { windowSize } from '../../../../../hooks/windowSize';
import { IOptionMap } from '../../../../../data/api/models';

interface OptionsDisplayProps {
  options: any[] | IOptionMap;
  optionName: string
}

export const OptionsDisplay = ({ options, optionName }: OptionsDisplayProps) => {

  let hasOption;
  let optionDataName = toLower(optionName.replace(' ', '_'))
  const isMobile = windowSize(600).isMobile;

  if (optionName === 'Enhanced Trip Disruption Cover') {
    optionDataName = 'enhanced_trip_disruption'
  }

  hasOption = optionName === 'Hazardous Activities' ?
    get(options, optionDataName, [])?.length ? get(options, 'hazardous_activities').join(', ') :
      <><img src={require('../../../../Quote/img/red-cross.svg')} alt={''}/><span style={{ paddingLeft: '10px' }}>You have <u>not</u> included</span></> :
    get(options, optionDataName, false) === true ?
      <><img src={require('../../../../Quote/img/green-tick.svg')} alt={''}/><span style={{ paddingLeft: '10px' }}>You have included</span></> :
      <><img src={require('../../../../Quote/img/red-cross.svg')} alt={''}/><span style={{ paddingLeft: '10px' }}>You have <u>not</u> included</span></>;

  return (
    <div style={{ display: 'flex' }}>
      <div style={{ maxWidth: '200px' }}>{optionName}</div>
      <div style={{ textAlign: isMobile ? 'right' : 'left' }}>{hasOption}</div>
    </div>
  )
}
